import React, { FC } from 'react'

import { useParams } from 'react-router'

import { ModerationStatus } from 'api/photo/photo.types'
import { PanelBottomView } from 'components/page/PhotoViewer/Panel/PanelBottom/PanelBottomView'
import { PhotoViewerParams } from 'components/page/PhotoViewer/PhotoViewer.paths'
import { PhotoViewerShareButton } from 'components/page/PhotoViewer/PhotoViewerShareButton'
import { useUserId } from 'hooks/useUserId'

import { usePhotos } from '../../hooks/usePhotos'

export const PanelBottom: FC<{
  selectedPhotoIndex: number
  isShowPanel?: boolean
}> = ({ selectedPhotoIndex, isShowPanel = true }) => {
  const { userId } = useParams<PhotoViewerParams>()
  const currentUserId = useUserId()
  const { photos } = usePhotos()

  const isCurrentUser = currentUserId === Number(userId)
  const selectedPhoto = photos[selectedPhotoIndex]

  const isShowPanelView =
    (isCurrentUser &&
      selectedPhoto.moderationStatus === ModerationStatus.approved) ||
    isShowPanel

  if (!isShowPanelView) {
    return null
  }

  const shareButton =
    selectedPhoto.moderationStatus !== ModerationStatus.rejected && userId ? (
      <PhotoViewerShareButton
        profileId={userId}
        photoId={selectedPhoto.photoId}
        dark={true}
        data-name="share-button-photoviewer-action"
      />
    ) : null

  return (
    <PanelBottomView
      photo={selectedPhoto}
      isCurrentUser={isCurrentUser}
      shareButton={shareButton}
    />
  )
}
